import { replaceValueAtPath } from 'helpers/utils'
import AppVersionsTypes from 'store/actionTypes/appVersion'
import UserTypes from '../actionTypes/user'

const initialData = {
  list: [],
  current: {},
  systems: [],
  pagination: {},
  filter: {}
}

const appVersion = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case AppVersionsTypes.GET_APP_VERSIONS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case AppVersionsTypes.GET_APP_VERSION_DETAIL_SUCCESS:
      return replaceValueAtPath(state, 'current', payload)
    case AppVersionsTypes.UPDATE_APP_VERSION_FILTER_SUCCESS:
      return replaceValueAtPath(state, 'filter', payload)
    case AppVersionsTypes.GET_SYSTEM_APP_VERSIONS_SUCCESS:
      return { ...state, systems: payload?.items?.appVersions }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default appVersion
